// extracted by mini-css-extract-plugin
module.exports = {"panel":"styles_panel__sYqMm","list":"styles_list__ttbmI","count":"styles_count__1PoH2","countLabel":"styles_countLabel__3unAg"};